import React from 'react';
import { REGISTRY_TARGETS } from './registryTargets';
import { FieldError, FieldHint, LabeledDropdown, SectionTitle } from './fields';

const ALIAS_ORDER = { dev: 0, prod: 1 };

function aliasLabel(target) {
  const alias = target.alias || 'dev';
  return alias.charAt(0).toUpperCase() + alias.slice(1);
}

/**
 * "Push to <registry>" destination picker (Figma: Environment dropdown).
 * ``targets`` are the DevOps-configured entries from org settings;
 * ``selectedIndex`` indexes into that array.
 */
export default function RegistryTargetSection({
  artifactType,
  targets,
  loading,
  selectedIndex,
  onSelect,
  showRequiredError,
  cloudBlockedMessage = null,
}) {
  const spec = REGISTRY_TARGETS[artifactType];
  if (!spec) return null;
  const options = targets
    .map((target, index) => ({ value: index, label: aliasLabel(target), alias: target.alias }))
    .sort((a, b) => (ALIAS_ORDER[a.alias] ?? 99) - (ALIAS_ORDER[b.alias] ?? 99));
  const selected = selectedIndex != null ? targets[selectedIndex] : null;
  const requiredError = showRequiredError && !selected ? spec.placeholder : null;

  return (
    <section className="configure-deployment-modal__section" aria-label={spec.title}>
      <SectionTitle description={spec.description}>{spec.title}</SectionTitle>
      <FieldError>{cloudBlockedMessage}</FieldError>
      <LabeledDropdown
        label="Environment"
        tooltip={spec.labelTooltip}
        options={options}
        value={selectedIndex}
        onChange={onSelect}
        placeholder={loading ? 'Loading…' : spec.placeholder}
        disabled={Boolean(cloudBlockedMessage) || loading}
        danger={Boolean(requiredError)}
      />
      {!loading && targets.length === 0 ? (
        <FieldHint>{spec.emptyHint}</FieldHint>
      ) : selected ? (
        <FieldHint>{spec.summary(selected)}</FieldHint>
      ) : (
        <FieldError>{requiredError}</FieldError>
      )}
    </section>
  );
}
